import React from 'react';
import { Users, Award, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Side - Image */}
          <div className="order-2 lg:order-1 flex justify-center lg:justify-start">
            <img 
              src="https://customer-assets.emergentagent.com/job_react-appacific/artifacts/lczc15jx_carpet_cleaning_technician.png"
              alt="Professional cleaning technician"
              className="rounded-lg shadow-lg max-w-full h-auto"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>

          {/* Right Side - Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 sm:mb-6">
              {t('about.welcomeTitle')}
            </h2>
            <p className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base">
              {t('home.aboutShort')}
            </p>
            <button className="border-2 border-blue-500 text-blue-500 px-4 sm:px-6 py-2 hover:bg-blue-500 hover:text-white transition-colors text-sm sm:text-base">
              {t('home.aboutButton')}
            </button>
          </div>
        </div>

        {/* Features Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
          <div className="text-center">
            <div className="bg-green-500 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <Users className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 leading-tight">
              {t('about.features.staff.title')}
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              {t('about.features.staff.description')}
            </p>
          </div>
          <div className="text-center">
            <div className="bg-green-500 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <Award className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 leading-tight">
              {t('about.features.tools.title')}
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              {t('about.features.tools.description')}
            </p>
          </div>
          <div className="text-center">
            <div className="bg-green-500 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <Clock className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 leading-tight">
              {t('about.features.service.title')}
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              {t('about.features.service.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;